import { useTranslate } from "@similarweb/i18n-provider";
import { DynamicIllustration } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { Button } from "@similarweb/ui-components";
import { Flex, Stack, Text } from "@similarweb/ui-components/foundations";

import { industryTransitionKeys } from "../../utils/i18n";

const ILLUSTRATION_SIZE = 160;

type RetryableErrorViewProps = {
    readonly title: string;
    readonly description: string;
    readonly canRetry: boolean;
    readonly onRetry: () => void;
    readonly dataAutomation: string;
};

export const RetryableErrorView = ({
    title,
    description,
    canRetry,
    onRetry,
    dataAutomation,
}: RetryableErrorViewProps) => {
    const { translate } = useTranslate();

    return (
        <Flex flex="1" alignItems="center" justifyContent="center" padding="32px">
            <Stack gap="12px" alignItems="center" data-automation={dataAutomation}>
                <DynamicIllustration illustrationName="ErrorBlue" size={ILLUSTRATION_SIZE} />

                <Text fontVariant="subtitle1" color={colorsPalettes.carbon[500]}>
                    {title}
                </Text>
                <Text fontVariant="body2" color={colorsPalettes.carbon[400]}>
                    {description}
                </Text>

                {canRetry ? (
                    <Button onClick={onRetry} data-automation={`${dataAutomation}-retry`}>
                        {translate(industryTransitionKeys.retry)}
                    </Button>
                ) : null}
            </Stack>
        </Flex>
    );
};
